import Log from "../assets/img/icon.log.svg";
import ButtonPlusIcon from "../assets/img/button.plus.svg";
import ButtonMinusIcon from "../assets/img/button.minus.svg";

const Icons = {
  Log,
  ButtonPlusIcon,
  ButtonMinusIcon,
};

export default Icons;
